// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3BTIj","content":"GlobalSearch_content__2kUk1"};